var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1090_7945",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#070A21",
    fillOpacity: 0.9
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1090_7945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 13.2179C9.90519 13.2179 9.80957 13.1984 9.71342 13.1594C9.61727 13.1204 9.52325 13.055 9.43138 12.9631L5.75669 9.28846C5.62208 9.15385 5.56039 8.99226 5.57161 8.80369C5.58282 8.61512 5.64879 8.46047 5.76952 8.33975C5.91802 8.19125 6.07827 8.12047 6.25027 8.12742C6.42227 8.13436 6.57558 8.20514 6.71019 8.33975L10.0003 11.6507L13.3032 8.34777C13.4378 8.21316 13.589 8.14452 13.7567 8.14184C13.9244 8.13917 14.0825 8.21209 14.231 8.36059C14.3656 8.4952 14.433 8.65198 14.433 8.83094C14.433 9.00988 14.3656 9.16666 14.231 9.30127L10.5692 12.9631C10.4773 13.055 10.3846 13.1204 10.2911 13.1594C10.1977 13.1984 10.1007 13.2179 10.0003 13.2179Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.03ec72bdbc2ab335119c77a1c718065b.svg";
export { ForwardRef as ReactComponent };